import React from 'react';
import { ShieldCheck } from 'lucide-react';
import styles from './PouchesRollHero.module.css';

const PouchesRollHero = ({
  badge,
  scriptTitle,
  mainTitleLines,
  kicker,
  descriptions,
  features,
  imagePrimary,
  imageSecondary,
}) => (
  <section className={styles.heroSection}>
    <div className={styles.splitLayout}>
      <div className={styles.greenPanel}>
        <div className={styles.panelInner}>
          <span className={styles.badge}>{badge}</span>

          <div className={styles.titleBlock}>
            <span className={styles.eyebrow}>{scriptTitle}</span>
            <h1 className={styles.title}>{mainTitleLines.join(' ')}</h1>
          </div>

          {kicker && <p className={styles.kicker}>{kicker}</p>}

          <div className={styles.bodyCopy}>
            {descriptions.slice(0, 2).map((text, index) => (
              <p key={index} className={styles.paragraph}>
                {text}
              </p>
            ))}
          </div>

          {features?.length > 0 && (
            <ul className={styles.featureRow}>
              {features.map((feature, index) => (
                <li key={index} className={styles.featureChip}>
                  <ShieldCheck size={12} aria-hidden="true" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <div className={styles.visualSide}>
        <div className={styles.imageStack}>
          {imagePrimary && (
            <figure className={styles.primaryFrame}>
              <img src={imagePrimary.src} alt={imagePrimary.alt} />
            </figure>
          )}
          {imageSecondary && (
            <figure className={styles.secondaryFrame}>
              <img src={imageSecondary.src} alt={imageSecondary.alt} />
            </figure>
          )}
          <span className={styles.accentBar} aria-hidden="true" />
          <span className={styles.accentCorner} aria-hidden="true" />
        </div>
      </div>
    </div>
  </section>
);

export default PouchesRollHero;
